"use client";

import { sbBlok } from "../../types/sb-types";
import TournamentCard from "./TournamentCard";
import Cta from "../Cta";
import { useEffect, useState } from "react";
import { Tournament } from "@/types/tournament";
import clsx from "clsx";
import { groupTournamentsBySeason } from "@/utils/tournaments";

interface TournamentCardOverviewProps {
  blok: sbBlok;
  tournaments: Array<Tournament>;
}

const TournamentCardOverview = ({
  blok,
  tournaments,
}: TournamentCardOverviewProps) => {
  const [isFirstRender, setIsFirstRender] = useState(true);
  const grouped = groupTournamentsBySeason(tournaments);
  const tournamentsToShow = grouped?.slice(0, 3);

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (tournamentsToShow?.length === undefined) {
    return null;
  }

  if (isFirstRender)
    return (
      <div className="grid-container mt-[30px] lg:mt-[50px] 2xl:mt-[110px]">
        <div className="col-start-1 col-span-4 lg:col-start-2 lg:col-span-14 2xl:col-start-4 2xl:col-span-26">
          <h1 className="text-[25px] mb-2.5" />
          <div className="flex flex-col justify-center items-center gap-[15px] mt-[40px] lg:flex-row lg:items-start lg:gap-2.5 lg:mt-2.5 2xl:gap-[30px] 2xl:mt-[25px]">
            <div className="rounded-[10px] bg-tm-c-gray-900 w-full md:max-w-[500px] h-[350px] lg:h-[370px] 2xl:h-[462px]" />
          </div>
        </div>
      </div>
    );

  return (
    <div
      className={clsx("grid-container mt-[30px] lg:mt-[50px] 2xl:mt-[110px]", {
        "pt-7 lg:pt-14":
          !!blok.spacing_top?.length && blok.spacing_top[0].option === "large",
        "pt-14 lg:pt-[120px]":
          !!blok.spacing_top?.length &&
          blok.spacing_top[0].option === "x_large",
        "pt-[120px] lg:pt-[180px]":
          !!blok.spacing_top?.length &&
          blok.spacing_top[0].option === "xx_large",
        "pb-7 lg:pb-14":
          !!blok.spacing_bottom?.length &&
          blok.spacing_bottom[0].option === "large",
        "pb-14 lg:pb-[120px]":
          !!blok.spacing_bottom?.length &&
          blok.spacing_bottom[0].option === "x_large",
        "pb-[120px] lg:pb-[180px]":
          !!blok.spacing_bottom?.length &&
          blok.spacing_bottom[0].option === "xx_large",
      })}
    >
      <div className="col-start-1 col-span-4 lg:col-start-2 lg:col-span-14 2xl:col-start-4 2xl:col-span-26">
        <>
          {blok.title && (
            <h1 className="text-[25px] mb-2.5 text-center">{blok.title}</h1>
          )}
          <div className="flex flex-col justify-center items-center gap-[15px] mt-[40px] lg:flex-row lg:items-start lg:gap-2.5 lg:mt-2.5 2xl:gap-[30px] 2xl:mt-[25px]">
            {tournamentsToShow?.map((tournament: Tournament) => (
              <TournamentCard key={tournament.id} tournament={tournament} />
            ))}
          </div>
          {blok.cta_link[0]?.link?.url && (
            <Cta
              className="mt-5 mx-auto mb-0 lg:mt-[55px]"
              href={blok.cta_link[0].link.url}
              fullSlug={blok.cta_link[0]?.link?.story?.full_slug}
              name={blok.cta_link[0]?.name}
            />
          )}
        </>
      </div>
    </div>
  );
};

export default TournamentCardOverview;
